module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.912ec66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/fontawesome-webfont.svg
// module id = 650
// module chunks = 1